import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { SmartInfoboxListProps } from "./types";
import {
  EntryOptions,
  PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { ImageChildrenDefinitions } from 'components/cms/definitions';
import { MetaTypeEnum } from 'app/shared';

export class SmartInfoboxListDefinitions extends CmsReactComponent<SmartInfoboxListProps> {
  static defaultProps = {};

  static schemaName = "smart-infobox-list";

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "cards",
      description: "İçerikler",
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [
          {
            mapping: {
              type: PropertyMappingType.String,
            },
            name: "title",
            text: "Başlık",
            description: "İçerikte gözükecek başlığı girin.",
          },
          {
            mapping: {
              type: PropertyMappingType.Textarea,
            },
            name: "description",
            text: "Açıklama",
            description: "İçerikte gözükecek kısa açıklamayı girin.",
          },
          {
            mapping: {
              type: PropertyMappingType.ParentObject,
              children: ImageChildrenDefinitions,
            },
            name: "image",
            text: "Fotoğraf",
            description: "İçerikte gözükecek arkaplan fotoğrafını girin.",
          }
        ],
      },
    },
  ];

  static options: EntryOptions = {
    meta: {
      use: true,
      allowedTypes: []
    },
    mappingFields: [
      {
        name: "anchor",
        text: "Sayfa URL",
        types: [MetaTypeEnum.Link],
      },
      {
        name: "title",
        text: "Başlık",
        types: [MetaTypeEnum.Text],
      },
      {
        name: "description",
        text: "Açıklama",
        types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
      },
      {
        name: "depth",
        text: "Derinlik",
        types: [MetaTypeEnum.Text],
      },
      {
        name: "location",
        text: "Lokasyon",
        types: [MetaTypeEnum.Text],
      },
      {
        name: "image",
        text: "Fotoğraf",
        types: [MetaTypeEnum.SingleImage],
      },
      {
        name: "mobileImage",
        text: "Mobil Fotoğraf",
        types: [MetaTypeEnum.SingleImage],
      },
      {
        name: "gallery",
        text: "Fotoğraf Galeri",
        types: [MetaTypeEnum.PhotoGallery]
      }
    ]
  };
}
